import React from 'react';
import './Footer.css';
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaFacebookF, FaTwitter, FaYoutube, FaInstagram } from 'react-icons/fa';
import logo  from '../assets/images/logo.png'

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="footer-column">
          <img src={logo} alt="RealAR Logo" className="footer-logo" />
          <p className="footer-desc">
            Skip the legal maze of land buying. Our verified plots come with pre-checked documents and expert approval.
          </p>
        </div>

        <div className="footer-column">
          <h4>Get In Touch</h4>
          <p><FaMapMarkerAlt className="icon" />  WeWork Krishe Emerald, Kondapur Main Road, Kondapur, Laxmi Cyber City, Whitefields, Hyderabad, Telangana 500084</p>
          <p><FaPhoneAlt className="icon" /> +91 9908173249 </p>
          <p><FaEnvelope className="icon" />contact@plotsverified.com</p>
        </div>

        <div className="footer-column">
          <h4>Useful Link</h4>
          <ul>
            <li>› Pricing Page</li>
            <li>› Privacy & Policy</li>
            <li>› What we do</li>
            <li>› Upcoming</li>
            <li>› Apply</li>
          </ul>
        </div>

        <div className="footer-column">
          <h4>Explore</h4>
          <ul>
            <li>› All Properties</li>
            <li>› All Authors</li>
            <li>› Our Team</li>
            <li>› Our Pricing</li>
            <li>› Our Products</li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© 2024 By Realar. All Rights Reserved.</p>
        <div className="footer-social">
          <a href="#"><FaFacebookF /></a>
          <a href="#"><FaTwitter /></a>
          <a href="#"><FaYoutube /></a>
          <a href="#"><FaInstagram /></a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
